import Service from "./ServiceCore";

export interface IExtension {
  id?: number;
  name: string;
  embedded: boolean;
  services?: Service[];
}

export default class Extension {
  private id?: number;
  private name: string;
  private embedded: boolean;
  private services?: Service[];

  constructor(dto: IExtension) {
    Object.assign(this, dto);
  }

  get getId(): number {
    return this.id;
  }

  set setId(id: number) {
    this.id = id;
  }

  get getName(): string {
    return this.name;
  }

  set setName(name: string) {
    this.name = name;
  }

  get getEmbedded(): boolean {
    return this.embedded;
  }

  set setEmbedded(embedded: boolean) {
    this.embedded = embedded;
  }

  get getServices(): Service[] {
    return this.services;
  }
}
